import axios from "axios";
import SideNavbar from "../../../components/common/SideNavbar";
import TopNavbar from "../../../components/common/TopNavbar";
import { useEffect, useState } from "react";
import { Button, Spinner, Modal } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { userTableCustomStyles } from "../../../utils/TableCustomStyles";

function ChargesMaster() {
  const [menuDrawerShow, setMenuDrawerShow] = useState(true);
  const [data, setData] = useState([]);
  const [dataPending, setDataPending] = useState(true);
  const [currentUserRolePermissionData, setCurrentUserRolePermissionData] =
    useState([]);
  const [dataFromTopNavBar, setDataFromTopNavBar] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const user_role = sessionStorage["userrole"];
  const user_id = sessionStorage["id"];
  const [loggedInUser, setLoggedInUser] = useState(null);

  const [showAddCanvas, setShowAddCanvas] = useState(false);
  const [showUpdateCanvas, setShowUpdateCanvas] = useState(false);
  const [canvasFullScreen, setCanvasFullScreen] = useState(false);

  const [showAddLoader, setShowAddLoader] = useState(false);
  const [showUpdateLoader, setShowUpdateLoader] = useState(false);
  const [showDeleteLoader, setShowDeleteLoader] = useState(false);

  const [recordForDelete, setRecordForDelete] = useState(null);

  // ----- Add form state
  const [name, setName] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [sacOrHsnCode, setSacOrHsnCode] = useState("");
  const [purchasable, setPurchasable] = useState("YES");
  const [saleable, setSaleable] = useState("YES");
  const [expenseLiking, setExpenseLiking] = useState("OPTIONAL");
  const [fixedAsset, setFixedAsset] = useState("NO");
  const [notes, setNotes] = useState("");

  // ----- Add form error states
  const [showNameError, setShowNameError] = useState(false);
  const [showDisplayNameError, setShowDisplayNameError] = useState(false);
  const [showSacOrHsnCodeError, setShowSacOrHsnCodeError] = useState(false);

  // ----- Add validation summary
  const [showValidationError, setShowValidationError] = useState(false);
  const [validationErrorArray, setValidationErrorArray] = useState([]);
  const [isValidationErrorVisible, setIsValidationErrorVisible] =
    useState(false);

  // ----- Update form state
  const [updateId, setUpdateId] = useState("");
  const [updateName, setUpdateName] = useState("");
  const [updateDisplayName, setUpdateDisplayName] = useState("");
  const [updateSacOrHsnCode, setUpdateSacOrHsnCode] = useState("");
  const [updatePurchasable, setUpdatePurchasable] = useState("");
  const [updateSaleable, setUpdateSaleable] = useState("");
  const [updateExpenseLiking, setUpdateExpenseLiking] = useState("");
  const [updateFixedAsset, setUpdateFixedAsset] = useState("");
  const [updateNotes, setUpdateNotes] = useState("");

  // ----- Update error states
  const [showUpdateNameError, setShowUpdateNameError] = useState(false);
  const [showUpdateDisplayNameError, setShowUpdateDisplayNameError] =
    useState(false);
  const [showUpdateSacOrHsnCodeError, setShowUpdateSacOrHsnCodeError] =
    useState(false);

  // ----- Update validation summary
  const [showUpdateValidationError, setShowUpdateValidationError] =
    useState(false);
  const [updateValidationErrorArray, setUpdateValidationErrorArray] = useState(
    [],
  );
  const [isUpdateValidationErrorVisible, setIsUpdateValidationErrorVisible] =
    useState(false);

  const [showUpdateChargeDetails, setShowUpdateChargeDetails] = useState(true);
  const [showUpdateTaxSettingDetails, setShowUpdateTaxSettingDetails] =
    useState(false);

  const [canvasAddFullScreen, setCanvasAddFullScreen] = useState(false);
  const [canvasUpdateFullScreen, setCanvasUpdateFullScreen] = useState(false);

  // Real‑time error helpers
  const hasAnyAddError = () => {
    return showNameError || showDisplayNameError || showSacOrHsnCodeError;
  };

  const buildAddErrorMessages = () => {
    const errors = [];
    if (!name) errors.push("Name is required");
    if (!displayName) errors.push("Display Name is required");
    if (!sacOrHsnCode) errors.push("SAC/HSN Code is required");
    return errors;
  };

  // Real‑time error helpers
  const hasAnyUpdateError = () => {
    return (
      showUpdateNameError ||
      showUpdateDisplayNameError ||
      showUpdateSacOrHsnCodeError
    );
  };

  const buildUpdateErrorMessages = () => {
    const errors = [];
    if (!updateName) errors.push("Name is required");
    if (!updateDisplayName) errors.push("Display Name is required");
    if (!updateSacOrHsnCode) errors.push("SAC/HSN Code is required");
    return errors;
  };

  // Click handlers for validation tooltips
  const handleCheckValidationClick = () => {
    setIsValidationErrorVisible(!isValidationErrorVisible);
  };

  const handleUpdateCheckValidationClick = () => {
    setIsUpdateValidationErrorVisible(!isUpdateValidationErrorVisible);
  };

  // ---- API calls
  const getLoggenInUser = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/user/" + user_id,
      );
      if (response) setLoggedInUser(response.data);
    } catch (err) {
      toast.error("Error in fetching user data! Try again.");
    }
  };

  const getCharges = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/charge/",
      );
      setTimeout(() => {
        if (response) {
          setData(response.data);
          setDataPending(false);
        }
      }, 500);
    } catch (err) {
      toast.error("Error in fetching charge data! Try again.");
    }
  };

  const getCurrentUserRolePermission = async (roles) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/role/getuserrolepermission?roles=" +
          roles,
      );
      const role_permissions_array = [];
      for (let i = 0; i < response.data?.length; i++) {
        for (let j = 0; j < response?.data[i]?.permissions_array?.length; j++) {
          if (
            !role_permissions_array.includes(
              response?.data[i]?.permissions_array?.[j],
            )
          ) {
            role_permissions_array.push(
              response?.data[i]?.permissions_array?.[j],
            );
          }
        }
      }
      if (role_permissions_array)
        setCurrentUserRolePermissionData(role_permissions_array);
    } catch (err) {
      toast.error("Error in fetching user role data! Try again.");
    }
  };

  useEffect(() => {
    getLoggenInUser();
    getCharges();
  }, []);

  useEffect(() => {
    getCurrentUserRolePermission(user_role);
  }, [user_role]);

  const columns = [
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Display Name",
      selector: (row) => row.display_name,
      sortable: true,
    },
    {
      name: "SAC or HSN Code",
      selector: (row) => row.sac_or_hsn_code,
      sortable: true,
    },
    {
      name: "Purchasable",
      selector: (row) => row.purchasable,
      sortable: true,
    },
    {
      name: "Saleable",
      selector: (row) => row.saleable,
      sortable: true,
    },
    {
      name: "Expense Liking",
      selector: (row) => row.expense_liking,
      sortable: true,
    },
    {
      name: "Fixed Asset",
      selector: (row) => row.fixed_asset,
      sortable: true,
    },
    {
      name: "Notes",
      selector: (row) => row.notes,
      sortable: true,
    },
    {
      name: "Action",
      center: true,
      selector: (row) => (
        <div>
          {currentUserRolePermissionData?.includes("master:charges:update") ? (
            <Button
              className="btn btn-sm btn-inox-green border-0"
              title="Update"
              onClick={() => {
                handleSetUpdateData(row);
                setShowUpdateCanvas(true);
              }}
            >
              <i className="fa fa-edit"></i>
            </Button>
          ) : (
            ""
          )}
          {currentUserRolePermissionData?.includes("master:charges:delete") ? (
            <Button
              className="btn btn-sm bg-danger border-0 mx-2"
              title="Delete"
              onClick={() => handleDeleteModalOpen(row)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          ) : (
            ""
          )}
        </div>
      ),
    },
  ];

  const handleDeleteModalClose = () => setShowDeleteModal(false);
  const handleDeleteModalOpen = (data) => {
    setShowDeleteModal(true);
    setRecordForDelete(data);
  };

  const deleteSelectedRecord = async (id) => {
    setShowDeleteLoader(true);
    try {
      await axios.delete(
        process.env.REACT_APP_BACKEND_API_URL + "/user/charge/" + id + "/",
      );
      setShowDeleteModal(false);
      getCharges();
      toast.success("Record deleted successfully");
    } catch (err) {
      toast.error("Error in deleting record! Try again.");
    }

    setShowDeleteLoader(false);
  };

  // ---- Add function ----
  const addNewCharge = async (e) => {
    e.preventDefault();

    // Update error states based on current values
    setShowNameError(!name);
    setShowDisplayNameError(!displayName);
    setShowSacOrHsnCodeError(!sacOrHsnCode);
    setValidationErrorArray(buildAddErrorMessages());

    if (!name || !displayName || !sacOrHsnCode) {
      setShowValidationError(true);
      return;
    }

    setShowAddLoader(true);

    const data = {
      name: name,
      display_name: displayName,
      sac_or_hsn_code: sacOrHsnCode,
      purchasable: purchasable,
      saleable: saleable,
      expense_liking: expenseLiking,
      fixed_asset: fixedAsset,
      notes: notes,
      created_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
    };

    try {
      const response = await axios.post(
        process.env.REACT_APP_BACKEND_API_URL + "/user/charge/",
        data,
        {
          headers: { "content-type": "application/json" },
        },
      );

      if (response.status === 201 || response.status === 200) {
        console.log("Success, showing toast");
        toast.success("Charge Created Successfully");
        handleAddModalClose();
      }
    } catch (err) {
      console.error(err);
      toast.error("Error creating charge");
    } finally {
      setShowAddLoader(false);
      getCharges();
    }
  };

  // ---- Set record for update
  const handleSetUpdateData = (row) => {
    setUpdateId(row.id);
    setUpdateName(row.name);
    setUpdateDisplayName(row.display_name);
    setUpdateSacOrHsnCode(row.sac_or_hsn_code);
    setUpdatePurchasable(row.purchasable);
    setUpdateSaleable(row.saleable);
    setUpdateExpenseLiking(row.expense_liking);
    setUpdateFixedAsset(row.fixed_asset);
    setUpdateNotes(row.notes);
  };

  // ---- Update function
  const updateCharge = async (e) => {
    e.preventDefault();

    setShowUpdateNameError(!updateName);
    setShowUpdateDisplayNameError(!updateDisplayName);
    setShowUpdateSacOrHsnCodeError(!updateSacOrHsnCode);
    setUpdateValidationErrorArray(buildUpdateErrorMessages());

    if (!updateName || !updateDisplayName || !updateSacOrHsnCode) {
      setShowUpdateValidationError(true);
      return;
    }

    setShowUpdateLoader(true);

    const data = {
      name: updateName,
      display_name: updateDisplayName,
      sac_or_hsn_code: updateSacOrHsnCode,
      purchasable: updatePurchasable,
      saleable: updateSaleable,
      expense_liking: updateExpenseLiking,
      fixed_asset: updateFixedAsset,
      notes: updateNotes,
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
    };

    try {
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/charge/" +
          updateId +
          "/",
        data,
        {
          headers: { "content-type": "application/json" },
        },
      );
      if (response.status === 201 || response.status === 200) {
        toast.success("Charge updated Successfully");
        handleUpdateModalClose();
      }
    } catch (err) {
      toast.error("Error updating charge");
    } finally {
      setShowUpdateLoader(false);
      getCharges();
    }
  };

  // ---- Reset add form when opening canvas ----
  const resetAddForm = () => {
    setName("");
    setDisplayName("");
    setSacOrHsnCode("");
    setPurchasable("YES");
    setSaleable("YES");
    setExpenseLiking("OPTIONAL");
    setFixedAsset("NO");
    setNotes("");
    setShowNameError(false);
    setShowDisplayNameError(false);
    setShowSacOrHsnCodeError(false);
    setShowValidationError(false);
    setValidationErrorArray([]);
  };
  const resetUpdateForm = () => {
    setUpdateId("");
    setUpdateName("");
    setUpdateDisplayName("");
    setUpdateSacOrHsnCode("");
    setUpdatePurchasable("");
    setUpdateSaleable("");
    setUpdateExpenseLiking("");
    setUpdateFixedAsset("");
    setUpdateNotes("");
    setShowUpdateNameError(false);
    setShowUpdateDisplayNameError(false);
    setShowUpdateSacOrHsnCodeError(false);
    setShowUpdateValidationError(false);
    setUpdateValidationErrorArray([]);
    setIsUpdateValidationErrorVisible(false);
  };
  const handleAddModalClose = () => {
    resetAddForm();
    setShowAddCanvas(false);
    setCanvasAddFullScreen(false);
  };

  // Update canvas close & reset

  const handleUpdateModalClose = () => {
    resetUpdateForm();
    setShowUpdateCanvas(false);
    setCanvasUpdateFullScreen(false);
  };
  function handleDataFromTopNavBar(permissiondata) {
    setDataFromTopNavBar(permissiondata);
  }

  return (
    <div className="page-content-bg">
      <TopNavbar
        sidebarCollapsed={menuDrawerShow}
        topNavbarStatic={true}
        sendDataToParent={handleDataFromTopNavBar}
      />
      <SideNavbar
        sidebarCollapsed={menuDrawerShow}
        activeMenu="Master"
        activeSubMenu="AdminMaster"
        activeSubMenuLevel1="ChargesMaster"
        permissionFromTopNavbar={dataFromTopNavBar}
      />
      <ToastContainer />

      <div
        className={
          menuDrawerShow
            ? "row main-content-collapsed text-left py-0"
            : "row main-content text-left py-0"
        }
      >
        <div className="col-12 page-header">
          <div className="row">
            <div className="col-6 py-1">
              <Button
                className="btn btn-sm btn-inox-green border-0 mx-2"
                onClick={() => setMenuDrawerShow(!menuDrawerShow)}
              >
                {menuDrawerShow ? (
                  <span>
                    <i className="fa fa-chevron-left mx-1"></i>
                  </span>
                ) : (
                  <span>
                    <i className="fa fa-chevron-right mx-1"></i>
                  </span>
                )}
              </Button>
              <span className="page-header-text">Charge Master</span>
            </div>
            <div className="col-6 py-1" style={{ paddingRight: 30 }}>
              {currentUserRolePermissionData?.includes(
                "master:customer:add",
              ) ? (
                <Button
                  className="btn btn-sm btn-inox-green border-0 px-3 float-right"
                  onClick={() => {
                    resetAddForm();
                    setShowAddCanvas(true);
                  }} // reset when opening
                >
                  <i
                    className="fa fa-plus fa-lg text-right"
                    style={{ paddingRight: 10 }}
                  ></i>
                  <span className="fw-bold">Add Charges</span>
                </Button>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>

        <div
          className="col-12 text-left"
          style={{
            marginTop: -5,
            paddingLeft: 20,
            paddingRight: 30,
            zIndex: 100,
          }}
        >
          <DataTable
            columns={columns}
            data={data}
            progressPending={dataPending}
            progressComponent={
              <Spinner
                className="mx-5 text-inox-green table-spinner"
                as="span"
                animation="border"
                size="lg"
                role="status"
                aria-hidden="true"
              />
            }
            noDataComponent={
              <p className="text-center table-no-data">No Data Found</p>
            }
            pagination
            highlightOnHover
            fixedHeader
            customStyles={userTableCustomStyles}
            dense
          />
        </div>
      </div>

      <Modal
        size="sm"
        show={showDeleteModal}
        onHide={handleDeleteModalClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteModalClose}>
            Close
          </Button>
          <Button
            variant="danger"
            onClick={() => deleteSelectedRecord(recordForDelete?.id)}
          >
            {showDeleteLoader ? (
              <Spinner
                className="mx-3 text-white"
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              "Delete"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ------------------------ Update Section ------------------- */}
      <div
        className={
          canvasUpdateFullScreen && showUpdateCanvas
            ? "offcanvas offcanvas-bottom h-100 show"
            : !canvasUpdateFullScreen && showUpdateCanvas
              ? "offcanvas offcanvas-bottom h-60 show"
              : "offcanvas offcanvas-bottom h-60"
        }
        id="updateSection"
        tabIndex="-1"
        aria-labelledby="offcanvasBottomLabel"
      >
        <div className="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="offcanvasBottomLabel" className="float-left">
                Update Record
              </h4>
              <Button
                className={`${showUpdateChargeDetails ? "btn-inox-red" : "btn-inox-green"} border-0 btn-sm`}
                style={{ marginRight: 10, width: 120 }}
                onClick={() => [
                  setShowUpdateChargeDetails(true),
                  setShowUpdateTaxSettingDetails(false),
                ]}
              >
                Details
              </Button>
              <Button
                className={`${showUpdateTaxSettingDetails ? "btn-inox-red" : "btn-inox-green"} border-0 btn-sm`}
                style={{ marginRight: 10, width: 120 }}
                onClick={() => [
                  setShowUpdateChargeDetails(false),
                  setShowUpdateTaxSettingDetails(true),
                ]}
              >
                Tax Settings
              </Button>
            </div>
            <div className="col-6">
              <button
                type="button"
                className="btn btn-danger btn-sm float-right"
                aria-label="Close"
                title="Close"
                onClick={handleUpdateModalClose}
              >
                <i className="fa fa-times text-white"></i>
              </button>
              {canvasUpdateFullScreen ? (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Half Screen"
                  onClick={() => [
                    setCanvasUpdateFullScreen(false),
                    setShowUpdateCanvas(true),
                  ]}
                >
                  <i className="fa fa-window-minimize text-white"></i>
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Full Screen"
                  onClick={() => [
                    setCanvasUpdateFullScreen(true),
                    setShowUpdateCanvas(true),
                  ]}
                >
                  <i className="fa fa-window-maximize text-white"></i>
                </button>
              )}
            </div>
          </div>
        </div>

        <div
          className="offcanvas-body"
          style={{ paddingLeft: 20, paddingRight: 40 }}
        >
          {showUpdateChargeDetails ? (
            <div>
              <form onSubmit={(e) => updateCharge(e)}>
                <div className="row">
                  {/* Name */}
                  <div
                    className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label className="required-label" htmlFor="update_name">
                      Name:
                      <span className="text-danger">
                        {showUpdateNameError ? "Name required" : ""}
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="update_name"
                      name="name"
                      placeholder="Enter Name"
                      value={updateName}
                      onChange={(e) => {
                        setUpdateName(e.target.value);
                        if (e.target.value !== "") {
                          setShowUpdateNameError(false);
                        } else {
                          setShowUpdateNameError(true);
                        }
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                      onBlur={(e) => {
                        setShowUpdateNameError(e.target.value === "");
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                    />
                  </div>

                  {/* Display Name */}
                  <div
                    className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label
                      className="required-label"
                      htmlFor="update_display_name"
                    >
                      Display Name:
                      <span className="text-danger">
                        {showUpdateDisplayNameError
                          ? "Display Name required"
                          : ""}
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="update_display_name"
                      name="display_name"
                      placeholder="Enter Display Name"
                      value={updateDisplayName}
                      onChange={(e) => {
                        setUpdateDisplayName(e.target.value);
                        if (e.target.value !== "") {
                          setShowUpdateDisplayNameError(false);
                        } else {
                          setShowUpdateDisplayNameError(true);
                        }
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                      onBlur={(e) => {
                        setShowUpdateDisplayNameError(e.target.value === "");
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                    />
                  </div>

                  {/* SAC/HSN Code */}
                  <div
                    className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label
                      className="required-label"
                      htmlFor="update_sac_or_hsn_code"
                    >
                      SAC/HSN Code:
                      <span className="text-danger">
                        {showUpdateSacOrHsnCodeError ? "Code required" : ""}
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="update_sac_or_hsn_code"
                      name="sac_or_hsn_code"
                      placeholder="Enter Code"
                      value={updateSacOrHsnCode}
                      onChange={(e) => {
                        setUpdateSacOrHsnCode(e.target.value);
                        if (e.target.value !== "") {
                          setShowUpdateSacOrHsnCodeError(false);
                        } else {
                          setShowUpdateSacOrHsnCodeError(true);
                        }
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                      onBlur={(e) => {
                        setShowUpdateSacOrHsnCodeError(e.target.value === "");
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                    />
                  </div>

                  {/* Optional fields – no validation */}
                  <div
                    className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label htmlFor="update_purchasable">Purchasable:</label>
                    <select
                      className="form-select form-select-sm"
                      name="purchasable"
                      value={updatePurchasable}
                      onChange={(e) => setUpdatePurchasable(e.target.value)}
                    >
                      <option value="YES">YES</option>
                      <option value="NO">NO</option>
                    </select>
                  </div>

                  <div
                    className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label htmlFor="update_saleable">Saleable:</label>
                    <select
                      className="form-select form-select-sm"
                      name="saleable"
                      value={updateSaleable}
                      onChange={(e) => setUpdateSaleable(e.target.value)}
                    >
                      <option value="YES">YES</option>
                      <option value="NO">NO</option>
                    </select>
                  </div>

                  <div
                    className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label htmlFor="update_expense_liking">
                      Expense Liking:
                    </label>
                    <select
                      className="form-select form-select-sm"
                      name="expense_liking"
                      value={updateExpenseLiking}
                      onChange={(e) => setUpdateExpenseLiking(e.target.value)}
                    >
                      <option value="OPTIONAL">OPTIONAL</option>
                      <option value="REQUIRED">REQUIRED</option>
                    </select>
                  </div>

                  <div
                    className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label htmlFor="update_fixed_asset">Fixed Asset:</label>
                    <select
                      className="form-select form-select-sm"
                      name="fixed_asset"
                      value={updateFixedAsset}
                      onChange={(e) => setUpdateFixedAsset(e.target.value)}
                    >
                      <option value="YES">YES</option>
                      <option value="NO">NO</option>
                    </select>
                  </div>

                  <div
                    className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label htmlFor="update_notes">Notes:</label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="update_notes"
                      name="notes"
                      placeholder="Enter Notes"
                      value={updateNotes}
                      onChange={(e) => setUpdateNotes(e.target.value)}
                    />
                  </div>

                  {/* Submit button */}
                  <div
                    className={`form-group ${canvasUpdateFullScreen ? "col-md-12" : "col-md-12"}`}
                  >
                    <div className="canvas-btn-row">
                      <Button
                        className="btn btn-inox-green border-0 canvas-button"
                        onClick={(e) => updateCharge(e)}
                        disabled={hasAnyUpdateError() || showUpdateLoader}
                      >
                        {showUpdateLoader ? (
                          <Spinner
                            className="mx-4"
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        ) : (
                          <>
                            <i className="fa fa-edit"></i>{" "}
                            <span className="mx-2">Update</span>
                          </>
                        )}
                      </Button>

                      {(hasAnyUpdateError() || showUpdateValidationError) && (
                        <div className="error-tooltip-wrapper">
                          <Button
                            style={{
                              backgroundColor: "#C21E22",
                              border: "#f82e2e",
                            }}
                            title="Show Errors"
                            className="mx-2"
                            onClick={handleUpdateCheckValidationClick}
                            onMouseLeave={() =>
                              setIsUpdateValidationErrorVisible(false)
                            }
                          >
                            <i className="fa fa-exclamation"></i>
                          </Button>
                          {isUpdateValidationErrorVisible && (
                            <div className="validation-error-tooltip">
                              <ul className="mb-0 px-4">
                                {updateValidationErrorArray.map(
                                  (error, index) => (
                                    <li
                                      key={index}
                                      className="text-left small pb-0"
                                    >
                                      {error}
                                    </li>
                                  ),
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </form>
            </div>
          ) : (
            ""
          )}

          {showUpdateTaxSettingDetails ? <div>TAX SETTINGS</div> : ""}
        </div>
      </div>

      {/* ------------------------ Add Section ------------------- */}
      <div
        className={
          canvasAddFullScreen && showAddCanvas
            ? "offcanvas offcanvas-bottom h-100 show"
            : !canvasAddFullScreen && showAddCanvas
              ? "offcanvas offcanvas-bottom h-60 show"
              : "offcanvas offcanvas-bottom h-60"
        }
        tabIndex="-1"
        id="addSection"
        aria-labelledby="offcanvasBottomLabel"
      >
        <div className="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="offcanvasBottomLabel" className="float-left">
                Add New Record
              </h4>
            </div>
            <div className="col-6">
              <button
                type="button"
                className="btn btn-danger btn-sm float-right"
                aria-label="Close"
                title="Close"
                onClick={handleAddModalClose}
              >
                <i className="fa fa-times text-white"></i>
              </button>
              {canvasAddFullScreen ? (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Half Screen"
                  onClick={() => [
                    setCanvasAddFullScreen(false),
                    setShowAddCanvas(true),
                  ]}
                >
                  <i className="fa fa-window-minimize text-white"></i>
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Full Screen"
                  onClick={() => [
                    setCanvasAddFullScreen(true),
                    setShowAddCanvas(true),
                  ]}
                >
                  <i className="fa fa-window-maximize text-white"></i>
                </button>
              )}
            </div>
          </div>
        </div>

        <div
          className="offcanvas-body"
          style={{ paddingLeft: 20, paddingRight: 40 }}
        >
          <form onSubmit={(e) => addNewCharge(e)}>
            <div className="row">
              {/* Name */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_name">
                  Name:
                  <span className="text-danger">
                    {showNameError ? "Name required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="add_name"
                  name="name"
                  placeholder="Enter Name"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                    if (e.target.value !== "") setShowNameError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowNameError(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* Display Name */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_display_name">
                  Display Name:
                  <span className="text-danger">
                    {showDisplayNameError ? "Display Name required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="add_display_name"
                  name="display_name"
                  placeholder="Enter Display Name"
                  value={displayName}
                  onChange={(e) => {
                    setDisplayName(e.target.value);
                    if (e.target.value !== "") setShowDisplayNameError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowDisplayNameError(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* SAC/HSN Code */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_sac_or_hsn_code">
                  SAC/HSN Code:
                  <span className="text-danger">
                    {showSacOrHsnCodeError ? "Code required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="add_sac_or_hsn_code"
                  name="sac_or_hsn_code"
                  placeholder="Enter Code"
                  value={sacOrHsnCode}
                  onChange={(e) => {
                    setSacOrHsnCode(e.target.value);
                    if (e.target.value !== "") setShowSacOrHsnCodeError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowSacOrHsnCodeError(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* Optional fields */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="add_purchasable">Purchasable:</label>
                <select
                  className="form-select form-select-sm"
                  name="purchasable"
                  value={purchasable}
                  onChange={(e) => {
                    setPurchasable(e.target.value);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                >
                  <option value="YES">YES</option>
                  <option value="NO">NO</option>
                </select>
              </div>

              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="add_saleable">Saleable:</label>
                <select
                  className="form-select form-select-sm"
                  name="saleable"
                  value={saleable}
                  onChange={(e) => {
                    setSaleable(e.target.value);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                >
                  <option value="YES">YES</option>
                  <option value="NO">NO</option>
                </select>
              </div>

              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="add_expense_liking">Expense Liking:</label>
                <select
                  className="form-select form-select-sm"
                  name="expense_liking"
                  value={expenseLiking}
                  onChange={(e) => {
                    setExpenseLiking(e.target.value);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                >
                  <option value="OPTIONAL">OPTIONAL</option>
                  <option value="REQUIRED">REQUIRED</option>
                </select>
              </div>

              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="add_fixed_asset">Fixed Asset:</label>
                <select
                  className="form-select form-select-sm"
                  name="fixed_asset"
                  value={fixedAsset}
                  onChange={(e) => {
                    setFixedAsset(e.target.value);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                >
                  <option value="YES">YES</option>
                  <option value="NO">NO</option>
                </select>
              </div>

              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="add_notes">Notes:</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="add_notes"
                  name="notes"
                  placeholder="Enter Notes"
                  value={notes}
                  onChange={(e) => {
                    setNotes(e.target.value);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* Submit button */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-12" : "col-md-12"}`}
              >
                {" "}
                <div className="canvas-btn-row">
                  <Button
                    className="btn btn-inox-green border-0 canvas-button"
                    onClick={(e) => addNewCharge(e)}
                    disabled={hasAnyAddError() || showAddLoader}
                  >
                    {showAddLoader ? (
                      <Spinner
                        className="mx-4"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      <>
                        <i className="fa fa-plus"></i>{" "}
                        <span className="mx-2">Add Charge</span>
                      </>
                    )}
                  </Button>

                  {(hasAnyAddError() || showValidationError) && (
                    <div className="error-tooltip-wrapper">
                      <Button
                        style={{
                          backgroundColor: "#C21E22",
                          border: "#f82e2e",
                        }}
                        title="Show Errors"
                        className="mx-2"
                        onClick={handleCheckValidationClick}
                        onMouseLeave={() => setIsValidationErrorVisible(false)}
                      >
                        <i className="fa fa-exclamation"></i>
                      </Button>
                      {isValidationErrorVisible && (
                        <div className="validation-error-tooltip">
                          <ul className="mb-0 px-4">
                            {validationErrorArray.map((error, index) => (
                              <li key={index} className="text-left small pb-0">
                                {error}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ChargesMaster;
